import VisibilityIcon from '@app/components/Icons/VisibilityIcon';
import { useHasError } from '@app/forms/components/FormGroup';
import { theme } from '@app/utils/material-ui/theme';
import { IconButton, InputAdornment, OutlinedInput } from '@mui/material';
import { OutlinedInputProps } from '@mui/material/OutlinedInput/OutlinedInput';
import React, { Component, useState } from 'react';

const CustomPasswordInput = (props: OutlinedInputProps): JSX.Element => {
  const hasError = useHasError();

  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <OutlinedInput
      type={showPassword ? 'text' : 'password'}
      size="small"
      error={!!hasError}
      sx={{ pr: 0 }}
      endAdornment={
        <InputAdornment position="end">
          <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword}>
            <VisibilityIcon sx={{ color: showPassword ? theme.palette.text.primary : theme.palette.text.auxiliary }} />
          </IconButton>
        </InputAdornment>
      }
      {...props}
    />
  );
};

export default class PasswordInput extends Component<OutlinedInputProps> {
  render() {
    return <CustomPasswordInput {...this.props} />;
  }
}
